import { render, staticRenderFns } from "./companiesGlobal.vue?vue&type=template&id=084ff6db&"
import script from "./companiesGlobal.vue?vue&type=script&lang=js&"
export * from "./companiesGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/NestJsProjects/ivm_web_ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('084ff6db')) {
      api.createRecord('084ff6db', component.options)
    } else {
      api.reload('084ff6db', component.options)
    }
    module.hot.accept("./companiesGlobal.vue?vue&type=template&id=084ff6db&", function () {
      api.rerender('084ff6db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/select/companiesGlobal.vue"
export default component.exports